import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { LoadingDiv, SweetAlertShow } from "../master/Master";
import LibraryLayout from "./LibraryLayout";
import { librariesList, libraryDueSummary } from "../../api/Library";
import {
  FeeCollectionTable,
  FeeDepositModal,
} from "./components/LibraryComponents";

export default function LibraryFees() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [libraries, setLibraries] = useState([]);
  const [libraryId, setLibraryId] = useState("");
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const studentId = searchParams.get("student");

  useEffect(() => {
    setLoading(true);
    librariesList()
      .then((r) => {
        if (r?.data?.status) setLibraries(r.data.data ?? []);
      })
      .catch((error) => {
        SweetAlertShow(
          "error",
          "Error",
          error?.response?.data?.message ??
            error?.response?.message ??
            error?.message,
        );
      })
      .finally(() => setLoading(false));
  }, []);

  const clearStudentParam = useCallback(() => {
    const next = new URLSearchParams(searchParams);
    next.delete("student");
    setSearchParams(next, { replace: true });
  }, [searchParams, setSearchParams]);

  useEffect(() => {
    if (!studentId) {
      setSelectedStudent(null);
      return;
    }

    setLoading(true);
    const params = new URLSearchParams();
    if (libraryId) params.set("library_id", libraryId);

    libraryDueSummary(params.toString())
      .then((r) => {
        if (!r?.data?.status) return;
        const row = (r.data.data ?? []).find(
          (item) => String(item.library_student_id) === String(studentId),
        );
        if (row) setSelectedStudent(row);
      })
      .catch((error) => {
        SweetAlertShow(
          "error",
          "Error",
          error?.response?.data?.message ??
            error?.response?.message ??
            error?.message,
        );
      })
      .finally(() => setLoading(false));
  }, [libraryId, studentId]);

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row">
                  <LibraryLayout />
                  <div className="col-12">
                    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                      <div>
                        <h3 className="mb-0 text-primary">Collect Fees</h3>
                        <p className="m-0">
                          Review monthly fee records and collect pending dues
                        </p>
                      </div>
                      <select
                        className="form-select"
                        style={{ width: "220px" }}
                        value={libraryId}
                        onChange={(e) => setLibraryId(e.target.value)}
                      >
                        <option value="">All Libraries</option>
                        {libraries.map((library) => (
                          <option key={library.id} value={library.id}>
                            {library.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <FeeCollectionTable
                      libraryId={libraryId}
                      refreshKey={refreshKey}
                      onRefresh={() => setRefreshKey((key) => key + 1)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {selectedStudent && (
        <FeeDepositModal
          student={selectedStudent}
          libraryId={libraryId}
          onClose={() => {
            setSelectedStudent(null);
            clearStudentParam();
          }}
          onSuccess={() => {
            setSelectedStudent(null);
            clearStudentParam();
            setRefreshKey((key) => key + 1);
          }}
        />
      )}
    </>
  );
}
